import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { SurtimientoService } from 'src/app/services/Almacen/surtimiento.service';

@Component({
  selector: 'app-surtimiento-detalle',
  templateUrl: './surtimiento-detalle.component.html',
  styleUrls: ['./surtimiento-detalle.component.scss']
})
export class SurtimientoDetalleComponent implements OnInit {

  public surtimientoDetalle: any;
  public firma: any;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild('signatureCanvas') canvas!: ElementRef<HTMLCanvasElement>;
  public dataSource: MatTableDataSource<any>;
  public displayedColumns: string[] = [];
  public partidas: any[];

  private ctx!: CanvasRenderingContext2D;
  private drawing = false;
  private hasSignature = false;

  constructor(
    private dialogRef: MatDialogRef<SurtimientoDetalleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private surtimientoService: SurtimientoService,
    private snackBar: MatSnackBar,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    console.log("Detalles surtimiento:", this.data);
    this.obtenerDetallePartidas();
  }

  obtenerDetallePartidas() {
    // this.spinner.show('spinner-detalle-surtimiento');
    this.surtimientoService.getDatalleSurtimiento(
      5,
      this.data.surtimiento.AlmacenID,
      this.data.surtimiento.SurtimientoID,
      this.data.surtimiento.Tipo)
      .subscribe((result: any) => {
        console.log("Detalle surtimiento:", result);
        this.partidas = result.data;
        this.dataSource = new MatTableDataSource(result.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.displayedColumns = ['Clave', 'Descripcion', 'Cantidad']

        this.firma = result.firma.firma;

        if (this.firma) {
          this.cargarFirma(this.firma);
        }

        // this.spinner.hide('spinner-detalle-surtimiento');
      });
  }

  ngAfterViewInit(): void {
    const context = this.canvas.nativeElement.getContext('2d');

    if (!context) {
      throw new Error('No se pudo obtener el contexto del canvas');
    }

    this.ctx = context;

    this.ctx.lineWidth = 2;
    this.ctx.lineCap = 'round';
    this.ctx.lineJoin = 'round';
    this.ctx.strokeStyle = '#000';
  }

  startDrawing(event: PointerEvent): void {
    this.drawing = true;

    const { x, y } = this.getPosition(event);

    this.ctx.beginPath();
    this.ctx.moveTo(x, y);
  }

  draw(event: PointerEvent): void {
    if (!this.drawing) {
      return;
    }

    const { x, y } = this.getPosition(event);

    this.ctx.lineTo(x, y);
    this.ctx.stroke();

    this.hasSignature = true;
  }

  stopDrawing(): void {
    this.drawing = false;
    this.ctx.closePath();
  }

  clearSignature(): void {
    const canvas = this.canvas.nativeElement;

    this.ctx.clearRect(
      0,
      0,
      canvas.width,
      canvas.height
    );

    this.hasSignature = false;
  }

  private getPosition(event: PointerEvent) {
    const canvas = this.canvas.nativeElement;
    const rect = canvas.getBoundingClientRect();

    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;

    return {
      x: (event.clientX - rect.left) * scaleX,
      y: (event.clientY - rect.top) * scaleY
    };
  }

  cargarFirma(base64: string): void {
    const canvas = this.canvas.nativeElement;
    const ctx = canvas.getContext('2d');

    if (!ctx) return;

    const img = new Image();

    img.onload = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ctx.drawImage(
        img,
        0,
        0,
        canvas.width,
        canvas.height
      );

      this.hasSignature = true;
    };

    img.src = `data:image/png;base64,${base64}`;
  }

  saveSignature(): void {
    this.spinner.show('spinner-detalle-surtimiento');
    if (!this.hasSignature) {
      console.log('El cliente no ha firmado');
      return;
    }

    const canvas = this.canvas.nativeElement;

    canvas.toBlob(blob => {

      if (!blob) {
        return;
      }

      console.log(blob);

      this.surtimientoService.postFirmaSurtimiento(
        5,
        this.data.surtimiento.AlmacenID,
        this.data.surtimiento.SurtimientoID,
        blob
      ).subscribe((result: any) => {
        this.spinner.hide('spinner-detalle-surtimiento');
        console.log("Firma guardada:", result);
        this.snackBar.open('Firma guardada correctamente', 'Cerrar', {
          duration: 3000
        });
      });

    }, 'image/png');
  }

  public cerrarModal = () => {
    this.dialogRef.close();
  }

}
